"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindingTypeValues = void 0;
exports.bindingTypeValues = {
    ConstantValue: 'ConstantValue',
    DynamicValue: 'DynamicValue',
    Factory: 'Factory',
    Instance: 'Instance',
    Provider: 'Provider',
    ResolvedValue: 'ResolvedValue',
    ServiceRedirection: 'ServiceRedirection',
};
//# sourceMappingURL=BindingType.js.map